import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=fab83e2c&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=fab83e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab83e2c",
  null
  
)

export default component.exports